import type {EditorJsonNode} from '~/features/portfolio/editor/composable/portfolioEditorItems';

interface ExtractedImages {
    cleanedContentBlocks: EditorJsonNode;
    imageFiles: File[];
    base64SrcToIndex: Map<string, number>;
}

export function extractBase64Images(contentBlocks: EditorJsonNode): ExtractedImages {
    const imageFiles: File[] = [];
    const base64SrcToIndex = new Map<string, number>();
    const cloned = JSON.parse(JSON.stringify(contentBlocks)) as EditorJsonNode;
    replaceBase64Nodes(cloned, imageFiles, base64SrcToIndex);
    return {cleanedContentBlocks: cloned, imageFiles, base64SrcToIndex};
}

function replaceBase64Nodes(node: EditorJsonNode, imageFiles: File[], base64SrcToIndex: Map<string, number>): void {
    if (node.type === 'image') {
        const attrs = node.attrs as Record<string, unknown> | undefined;
        const src = attrs?.src;
        if (typeof src === 'string' && src.startsWith('data:')) {
            const index = imageFiles.length;
            base64SrcToIndex.set(src, index);
            imageFiles.push(dataUrlToFile(src, `image_${index}`));
            attrs!.src = `@img:${index}`;
        }
        return;
    }
    node.content?.forEach((child) => replaceBase64Nodes(child, imageFiles, base64SrcToIndex));
}

function dataUrlToFile(dataUrl: string, filename: string): File {
    const [header, data] = dataUrl.split(',');
    const mime = header?.match(/:(.*?);/)?.[1] ?? 'image/jpeg';
    const ext = mime.split('/')[1]?.replace('jpeg', 'jpg') ?? 'jpg';
    const bytes = atob(data ?? '');
    const arr = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        arr[i] = bytes.charCodeAt(i);
    }
    return new File([arr], `${filename}.${ext}`, {type: mime});
}
